import ComingSoon from "../../components/ComingSoon/ComingSoon";
export default function ComingSoonScreen() {
    return (
       <ComingSoon/>
    )
}